import httpClient from './httpClient';

// Caixa de avisos do sino (BFF: backoffice/alerts). O dono é sempre quem está logado: nenhuma rota recebe o id de uma pessoa.
const base = '/backoffice/alerts';

export const listAlerts = async ({ unreadOnly = false, limit = 30 } = {}) =>
    (await httpClient.get(base, { params: { unreadOnly, limit } })).data;

export const getUnreadCount = async () => (await httpClient.get(`${base}/unread-count`)).data.unread;

export const markAlertRead = async (id) => (await httpClient.post(`${base}/read`, { id })).data;

export const markAllAlertsRead = async () => (await httpClient.post(`${base}/read-all`)).data;
